import createIcon from '../../createIcon';

/**
 * @component @name Subtitles
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNEg0QzIuOSA0IDIgNC45IDIgNlYxOEMyIDE5LjEgMi45IDIwIDQgMjBIMjBDMjEuMSAyMCAyMiAxOS4xIDIyIDE4VjZDMjIgNC45IDIxLjEgNCAyMCA0Wk00IDEySDhWMTRINFYxMlpNMTQgMThINFYxNkgxNFYxOFpNMjAgMThIMTZWMTZIMjBWMThaTTIwIDE0SDEwVjEySDIwVjE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Subtitles = createIcon('Subtitles', [
  [
    'path',
    {
      d: 'M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM4 12H8V14H4V12ZM14 18H4V16H14V18ZM20 18H16V16H20V18ZM20 14H10V12H20V14Z',
      key: '10y5g4',
    },
  ],
]);

export default Subtitles;
